// extracted by mini-css-extract-plugin
export default {"tryAgain":"F_cb","result":"F_cc"};